import {
  NAState,
  NAAction,
  NAInProgressAction,
  NAInProgress,
  NA_IN_PROGRESS,
  NA_STARTED,
  NA_SUBMIT,
  NASubmit,
  NA_CHECKBOX,
  NACheckboxUpdate,
  NA_COMPLETED
} from './types';
import { RESET_STORE, STORE } from '../global';
import { checkWhitelist } from '../reducer-utils';
import { get } from 'lodash';

const initialState = { inProgressNA: {} };

export const needAnalysis = (state: NAState = { inProgressNA: {} }, action: NAAction | NAInProgressAction): NAState => {
  switch (action.type) {
    case NA_IN_PROGRESS: {
      const act = action.payload as NAInProgress;
      return {
        ...state,
        inProgressNA: act
      };
    }
    case NA_SUBMIT: {
      const { paxNa } = action.payload as NASubmit;
      return { ...state, ...paxNa };
    }
    case NA_CHECKBOX: {
      const { paxId, uniqueKey, value } = action.payload as NACheckboxUpdate;
      const currPaxNa = get(state, paxId);
      if (currPaxNa) {
        const currentStateValue = currPaxNa[0];
        const obj = {};
        obj[uniqueKey] = value;
        return {
          ...state,
          [paxId]: [
            {
              questions: {
                ...currentStateValue.questions,
                ...obj
              }
            }
          ]
        };
      } else {
        const newValue = {};
        newValue[uniqueKey] = value;
        return {
          ...state,
          [paxId]: [
            {
              questions: {
                ...newValue
              }
            }
          ]
        };
      }
    }
    case NA_COMPLETED: {
      // @ts-ignore
      const isNACompleted = action.payload as boolean;
      return { ...state, isNACompleted };
    }
    case NA_STARTED:
      // @ts-ignore
      return { ...state, naStarted: action.payload as boolean };

    case RESET_STORE:
      return checkWhitelist(action.payload.whitelist, STORE.NA, state, initialState) as NAState;
    default:
      return state;
  }
};
